import { parseCounselorPbxExtension } from '@/services/sip/counselorExtensions';
function toNumericIds(ids) {
    if (!ids?.length)
        return undefined;
    const numeric = ids.map((id) => Number(id)).filter((n) => Number.isFinite(n));
    return numeric.length > 0 ? numeric : undefined;
}
export function extractPhoneDigits(raw) {
    const trimmed = raw.trim();
    if (!trimmed)
        return '';
    const counselorDigits = parseCounselorPbxExtension(trimmed);
    if (counselorDigits)
        return counselorDigits;
    const angle = trimmed.match(/<(\d[\d+#*]*)>/);
    if (angle)
        return angle[1].replace(/\D/g, '');
    const digits = trimmed.replace(/\D/g, '');
    return digits;
}
export function mapCrmPhoneToPanelPhone(crm, fallbackNumber) {
    return {
        id: crm.id,
        number: crm.number ?? fallbackNumber ?? '',
        name: crm.name,
        email: crm.email,
        callerTitle: crm.callerTitle,
        socialMedia: crm.socialMedia,
        province: crm.province?.id != null ? { id: String(crm.province.id), name: crm.province.name ?? '' } : null,
        district: crm.district?.id != null ? { id: String(crm.district.id), name: crm.district.name ?? '' } : null,
        villageName: crm.villageName,
        customerGroup: crm.groups?.[0]?.name,
    };
}
export function mapCaseRowToPanelPhone(row, fallbackNumber) {
    const extended = row;
    return {
        id: extended.phoneId ?? row.customerId,
        number: row.phoneNumber ?? fallbackNumber,
        name: row.callerName,
        callerTitle: extended.callerTitle,
        email: row.customerEmail,
        province: extended.provinceId != null || row.province?.id != null
            ? {
                id: String(extended.provinceId ?? row.province?.id),
                name: extended.provinceName ?? row.province?.name ?? '',
            }
            : null,
        district: extended.districtId != null || row.district?.id != null
            ? {
                id: String(extended.districtId ?? row.district?.id),
                name: extended.districtName ?? row.district?.name ?? '',
            }
            : null,
        villageName: row.villageName,
    };
}
export function validatePhoneProfileForCreate(phone) {
    if (!phone.number?.trim())
        return 'Caller ID is required';
    if (!phone.callerTitle?.trim())
        return 'Caller Title is required';
    if (!phone.name?.trim())
        return 'Caller Name is required';
    if (!phone.province?.id)
        return 'Province is required';
    if (!phone.district?.id)
        return 'District is required';
    return null;
}
export function mapPanelPhoneToCrmPayload(phone) {
    const payload = {
        number: phone.number,
        name: phone.name ?? '',
        callerTitle: phone.callerTitle,
        email: phone.email?.trim() || undefined,
        villageName: phone.villageName ?? '',
    };
    if (phone.id != null && phone.id !== '') {
        payload.id = Number(phone.id);
    }
    if (phone.province?.id) {
        payload.province = {
            id: Number(phone.province.id),
            name: phone.province.name,
        };
    }
    if (phone.district?.id) {
        payload.district = {
            id: Number(phone.district.id),
            name: phone.district.name,
        };
    }
    return payload;
}
export function buildAgentCaseCreatePayload(phone, caseForm, reference, queueLog, callLink) {
    const branch = reference?.branches.find((b) => b.id === caseForm.branchId);
    const selectedAgentIds = toNumericIds(caseForm.agentIds);
    const selectedDepartmentIds = toNumericIds(caseForm.departmentIds);
    return {
        remark: caseForm.remark ?? '',
        subject: caseForm.subject ?? '',
        followUp: caseForm.followUp ?? false,
        issueId: caseForm.issueId ? Number(caseForm.issueId) : undefined,
        priority: caseForm.priority || undefined,
        socialMedia: caseForm.socialMedia || undefined,
        callerTitle: phone.callerTitle,
        callerName: phone.name,
        customerEmail: phone.email?.trim() || undefined,
        phoneId: phone.id != null && phone.id !== '' ? Number(phone.id) : undefined,
        phoneNumber: phone.number,
        provinceId: phone.province?.id ? Number(phone.province.id) : undefined,
        provinceName: phone.province?.name,
        districtId: phone.district?.id ? Number(phone.district.id) : undefined,
        districtName: phone.district?.name,
        villageName: phone.villageName,
        branchId: caseForm.branchId ? Number(caseForm.branchId) : undefined,
        branchName: branch?.branchName,
        ...(selectedAgentIds ? { selectedAgentIds } : {}),
        ...(selectedDepartmentIds ? { selectedDepartmentIds } : {}),
        ...(callLink
            ? { kaseId: callLink.kaseId, refUniqueId: callLink.refUniqueId }
            : {
                ...(queueLog?.callid?.trim() ? { uniqueId: queueLog.callid.trim() } : {}),
                ...(queueLog?.queuename?.trim() ? { queueName: queueLog.queuename.trim() } : {}),
                ...(queueLog ? { respondedAgentInQueueLog: queueLog } : {}),
            }),
    };
}
